import { staticPath } from '../../utils/common';

export const Timeout = () => {
  return (
    <div className={`ptm-time-out-wrap`}>
      <img
        src={`${staticPath()}/assets/images/timeout.png`}
        alt="time out"
        className={`ptm-margin0`}
      />
      <div className={`ptm-main-text ptm-body-color`}>
        Your session has timed out due to inactivity
      </div>
      <div className={`ptm-sub-text ptm-body-color`}>Please go back to try again.</div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/timeOut/index.js